export default __webpack_public_path__ + "static/media/paracetamol-1-gr-biogaran-boite-de-8-cps.24e1452f.jpg";